import { render, staticRenderFns } from "./viewAUDIO.vue?vue&type=template&id=3543c5bb"
import script from "./viewAUDIO.vue?vue&type=script&lang=js"
export * from "./viewAUDIO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports